import React from "react";

import user_progress from "./user_progress.png";
import user_progress_detail from "./user_progress_detail.png";

const ShowingUserProgress = () => (
  <div id="admin_user_progress" className="section">
    <h2>3.4 User Progress</h2>
    <p>By clicking on the progress tab on the Edit user page you can view the user's progress:</p>
    <img src={user_progress} alt="User Progress" className="center" />
    <p>Click on one of the courses to see further detail, and change the status.</p>
    <img src={user_progress_detail} alt="User Progress Detail" className="center" />
  </div>
);

export default ShowingUserProgress;
